module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Following.81f3b9e8.svg";